<template>
  <div class style="margin-bottom: 10px">
    <p style="line-height:18px;height:30px" v-if="isIOS">
      <i-switch style="float:right" :disabled="!isIOSPlayer" @on-change="onIOSToggleNotif" v-model="isIOSToggleNotification"></i-switch>
      <span>
        <p v-if="isOnboarding">Allow Notification</p>
        <b v-else>Allow Notification</b>
        <small v-if="isIOSPlayer" style="display:block;color:#aaa">This is a notification setting for native IOS.</small>
        <small v-else style="display:block;color:rgb(239, 83, 80)">(Notification not supported by this browser.)</small>
      </span>
    </p>
    <p style="line-height:18px;height:30px" v-if="!isIOS">
      <!-- <Button :disabled="$store.state.supportPush && !$store.state.notifSubscription"
        @click="enableNotif()" style="float:right">
      {{ ($store.state.notifSubscription) ?'Disable':'Enable' }}</Button>-->
      <i-switch
        style="float:right;margin-top:7px"
        @on-change="change"
        :disabled="!$store.state.supportPush"
        v-model="isSubscribed"
      ></i-switch>
      <span>
        <p v-if="isOnboarding">Allow Notification</p>
        <b v-else>Allow Notification</b>
        <small
          style="display:block;color:rgb(239, 83, 80)"
          v-if="!$store.state.supportPush"
        >(Notification not supported by this browser.)</small>
        <small
          style="display:block;color:#aaa;margin-top: 6px;"
          v-if="$store.state.supportPush"
        >Notification supported by this browser.</small>
      </span>
    </p>
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import utils from "@/utils.js";

export default {
  data() {
    return {
      isToggleIOSNotif: false
    };
  },
  props: {
    isOnboarding: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted() {
    checkReminderNotifCookie = setInterval(
      function() {
        this.isIOSToggleNotification = this.readOnToggleNotificationCookie(
          "onToggleNotification"
        );
      }.bind(this),
      1000
    );
  },
  beforeDestroy() {
    clearInterval(window.checkReminderNotifCookie);
  },
  computed: {
    isIOS() {
      return utils.checkMobileOS() == "iOS";
    },
    isIOSPlayer () {
      return VueCookie.get('os_type') === "ios"
    },
    isSubscribed: {
        get() {
          return JSON.parse(window.localStorage.getItem("notification_enabled")) == true
        },
        set(v) {
          // this.$store.state.notifSubscription = v
        }
    },
    isIOSToggleNotification: {
      get() {
        return this.$store.state.enableNotifIOSButton &&
          this.$store.state.enableNotifIOSButton != 0
          ? true
          : false;
      },
      set(v) {
        this.$store.state.enableNotifIOSButton = v;
      }
    }
  },
  methods: {
    readOnToggleNotificationCookie(name) {
      return (
        VueCookie.get("onToggleNotification") == "1" ||
        VueCookie.get("onToggleNotification") == 1
      );
    },
    onIOSToggleNotif(v) {
      if (this.isIOS) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: "onToggleNotification",
          params: {
            isOn: v
          }
        });
      }
    },
    change(status) {
      this.enableNotif();
    },
    enableNotif() {
      let btn = document.querySelector("#PUSHNOTIF");
      btn.click();
    }
  }
};
</script>
